<template>
  <div class="section fondu" :class="{'fonduenter': settings['.key']}">
    <!-- notification -->
    <transition mode="out-in" name="fade">
      <div v-if="notification.message" :class="'notification is-' + notification.type">
        <button class="delete" @click="hideNotifications"></button>{{notification.message}}
      </div>
    </transition>
    <!-- modal for add setting -->
    <transition mode="out-in" name="fade">
      <modal @close="showModal = false" :kind="kind" @addSetting='confirmAddSetting' @confirmDeleteSetting="confirmDeleteSetting()" v-if="showModal" :header="header"/>
    </transition>
    <div class="card">
      <div class="card-header">
        <p class="card-header-title">Paramètres</p>
        <span class="icon has-text-info help-btn">
          <a href="https://theadmin.thecompagnie.eu/doc?bloc=Paramètres" target="_blank"><i class="fa fa-question-circle"></i></a>
        </span>
      </div>
      <div class="card-content principal">
        <div class="content">
          <div class="card">
            <div class="card-header">
              <p class="card-header-title">Logo du site</p>
              <span class="icon has-text-info help-btn">
                <a href="https://theadmin.thecompagnie.eu/doc?bloc=Logo%20du%20site" target="_blank"><i class="fa fa-question-circle"></i></a>
              </span>
            </div>
            <div class="card-content">
              <div class="content">
                <div class="control">
                  <figure class="image is-128x128" style="border: 1px solid lightgrey; background-position: center; background-repeat: no-repeat;" :style="{ 'background-image': 'url(' + loadLogo + ')' }">
                  </figure>
                  <div class="file">
                    <label class="file-label">
                      <input @change="uploadWebsiteLogo" class="file-input" type="file" name="resume">
                      <span class="file-cta">
                        <span class="file-icon">
                          <i class="fa fa-upload"></i>
                        </span>
                        <span class="file-label">
                          Choisir un logo…
                        </span>
                      </span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <br />
          <div class="card">
            <div class="card-header">
              <p class="card-header-title">Champs paramètres</p>
              <span class="icon has-text-info help-btn">
                <a href="https://theadmin.thecompagnie.eu/doc?bloc=Champs%20paramètres" target="_blank"><i class="fa fa-question-circle"></i></a>
              </span>
            </div>
            <div class="card-content">
              <div class="content">
                <div v-for="(field, key) in settings" class="field columns" :key="key" v-if="key !== '.key'">
                  <div class="control column is-two-thirds">
                    <input type="text" class="input" :name="field" :placeholder="field" v-model="settings[key]">
                  </div>
                  <div class="column is-one-third has-text-left">
                    <span class="tag">
                      {{key}}
                      <button class="delete is-small" @click="deleteSettingsField(key)" style="margin-left: 5px;"></button>
                    </span>
                  </div>
                </div>
                <!-- Main container -->
                <nav class="level">
                  <div class="level-left">
                    <div class="level-item">
                      <button type="button" class="button is-pulled-right" @click="addSettingField">
                        Ajouter un champ paramètre
                      </button>
                    </div>
                    <div class="level-item">
                      <button type="button" class="button is-info is-pulled-right" @click="saveSettings">
                        Enregistrer les paramètres
                      </button>
                    </div>
                  </div>
                  <div class="level-right">
                  </div>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <br />
    <!-- nav builder -->
    <nav-builder></nav-builder>
  </div>
</template>

<script>
import firebase from 'firebase'
import { allRef, mediaRef, settingsRef } from '@/admin/firebase_config'
import notifier from '@/admin/mixins/notifier'
import modal from '@/admin/components/shared/Modal'
import NavBuilder from './NavBuilder'
import imageLoader from '@/admin/mixins/image-loader'

export default {
  name: 'settings',
  data () {
    return {
      updatesCounter: 0,
      // this array contains settings form fields
      fields: [
        {
          label: 'Site Title',
          name: 'title',
          value: ''
        },
        {
          label: 'Site Description',
          name: 'description',
          value: ''
        }
      ],
      showModal: false,
      header: '',
      kind: '',
      deleteKey: '',
      websiteLogo: ''
    }
  },
  firebase: {
    // load settings as an object instead of array (default)
    settings: {
      source: settingsRef,
      asObject: true
    },
    all: allRef,
    media: mediaRef
  },
  mixins: [notifier, imageLoader],
  computed: {
    loadLogo () {
      var i = this.media.length
      var url = null
      while (i--) {
        if (this.media[i].name === 'WebsiteLogo') {
          url = this.media[i].src
        }
      }
      return url
    }
  },
  methods: {
    saveSettings () {
      delete this.settings['.key'] // This is a bit weird but no problem
      this.$firebaseRefs.settings.update(this.settings).then(() => {
        this.showNotification('success', 'Paramètres sauvegarder avec succés')
      })
    },
    // display the loaded settings
    displaySettings () {
      for (let key in this.settings) {
        this.fields.map((field) => {
          if (field.name === key) {
            field.value = this.settings[key]
            return this.settings[key]
          }
        })
      }
    },
    addSettingField () {
      this.header = 'Nom du nouveau paramètre: '
      this.kind = 'addSetting'
      this.showModal = true
    },
    confirmAddSetting (value) {
      if (value === '') {
        this.showNotification('danger', 'Ajouter le nom du paramètre en premier')
        return
      }
      if (this.settings.hasOwnProperty(value)) {
        this.showNotification('danger', 'Ce paramètre éxiste déjà')
        return
      }

      this.$firebaseRefs.settings.update({
        [value]: ''
      }).then(() => {
        this.showNotification('success', 'Paramètre ajouté avec succés')
        this.showModal = false
      }).catch(() => {
        this.showNotification('error', 'Paramètre pas ajouté')
      })
    },
    deleteSettingsField (key) {
      this.header = 'Êtes-vous certain de supprimer ce paramètre?'
      this.kind = 'deleteSetting'
      this.showModal = true
      this.deleteKey = key
    },
    confirmDeleteSetting () {
      this.$firebaseRefs.settings
        .child(this.deleteKey)
        .remove()
        .then(() => {
          this.showNotification('success', 'Paramètre supprimé avec succés')
          this.showModal = false
          this.deleteKey = ''
          this.kind = ''
        })
        .catch((e) => {
          this.showNotification('error', 'Paramètre pas supprimé')
        })
    },
    uploadWebsiteLogo (e) {
      console.log(e)
      let file = e.target.files[0]
      let storageRef = firebase.storage().ref('images/' + file.name)

      var i = this.media.length
      var currentLogo = null
      while (i--) {
        if (this.media[i].name === 'WebsiteLogo') {
          currentLogo = this.media[i]
        }
      }
      storageRef.put(file).then((snapshot) => {
        console.log(snapshot)
        this.websiteLogo = snapshot.downloadURL

        var logo = {
          src: snapshot.downloadURL,
          path: snapshot.ref.fullPath,
          name: 'WebsiteLogo'
        }
        // let tempLogo = {...currentLogo}

        if (currentLogo) {
          // delete tempLogo[key]
          this.$firebaseRefs.media.child(currentLogo['.key']).set(logo)
            .then(() => {
              this.showNotification('success', 'Logo ajouté avec succés')
            })
        } else {
          if (Object.values(this.media).find(e => e.path === snapshot.ref.fullPath)) return
          this.$firebaseRefs.media.push({
            src: snapshot.downloadURL,
            path: snapshot.ref.fullPath,
            name: 'WebsiteLogo'
          }).then(() => {
            this.showNotification('success', 'Logo ajouté avec succés')
          })
        }
      })
    }
  },
  updated () {
    // run the loaded settings once
    if (this.updatesCounter === 0) {
      this.displaySettings()
    }
    this.updatesCounter++
  },
  components: {
    modal,
    NavBuilder
  }
}

</script>
<style lang="scss" scoped>
.section{
  padding: 0 !important;
  padding-top: 1em !important;
}
.bulma .card .card-content.principal{
  padding: 0 !important;
}
.bulma .card-content{
  padding: 0 !important;
}
.bulma .columns{
  padding: 0 !important;
}
.bulma .column{
  padding: 0 !important;
}
.content{
  padding: 1em !important;
}
</style>



// WEBPACK FOOTER //
// src/admin/pages/settings/Settings.vue